import { Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AlphaSharedModule } from '../../../shared/alpha-shared.module';
@Component({
    selector: 'app--confirm-dialog',
    standalone: true,
    imports: [AlphaSharedModule],
    templateUrl: './confirm-dialog.component.html',
    styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
    private dialogRef = inject(DynamicDialogRef);
    private config = inject(DynamicDialogConfig);

    description: string = '';
    constructor() {
        this.description = this.config.data.description || '';
    }

    onButtonClick(data: boolean) {
        this.dialogRef.close(data);
    }
}
